module.exports = __webpack_public_path__ + "img/bg_2.5976b124.webp";